// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "groupfolders-" + chunkId + ".js?v=" + {"vendors-node_modules_nextcloud_vue_dist_ncvuecomponents_js-node_modules_css-loader_dist_runti-78a4de":"d14d23ac915283b7644e","sharing":"26deff214ee47168b803"}[chunkId] + "";
};